"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var connector_1 = __importDefault(require("./lib/connector"));
var noop_1 = __importDefault(require("licia/noop"));
var uuid_1 = __importDefault(require("licia/uuid"));
var each_1 = __importDefault(require("licia/each"));
var Emitter_1 = __importDefault(require("licia/Emitter"));
var util_1 = require("./lib/util");
var Chobitsu = (function () {
    function Chobitsu() {
        var _this = this;
        this.resolves = new Map();
        this.domains = new Map();
        this.onMessage = noop_1.default;
        connector_1.default.on('message', function (message) {
            var parsedMessage = JSON.parse(message);
            var resolve = _this.resolves.get(parsedMessage.id);
            if (resolve) {
                resolve(parsedMessage.result);
            }
            if (!parsedMessage.id) {
                var _a = parsedMessage.method.split('.'), name_1 = _a[0], method = _a[1];
                var domain = _this.domains.get(name_1);
                if (domain) {
                    domain.emit(method, parsedMessage.params);
                }
            }
            _this.onMessage(message);
        });
    }
    Chobitsu.prototype.domain = function (name) {
        return this.domains.get(name);
    };
    Chobitsu.prototype.setOnMessage = function (onMessage) {
        this.onMessage = onMessage;
    };
    Chobitsu.prototype.sendMessage = function (method, params) {
        var _this = this;
        if (params === void 0) { params = {}; }
        var id = (0, uuid_1.default)();
        this.sendRawMessage(JSON.stringify({
            id: id,
            method: method,
            params: params,
        }));
        return new Promise(function (resolve) {
            _this.resolves.set(id, resolve);
        });
    };
    Chobitsu.prototype.sendRawMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var parsedMessage, method, params, id, resultMsg, _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        parsedMessage = JSON.parse(message);
                        method = parsedMessage.method, params = parsedMessage.params, id = parsedMessage.id;
                        resultMsg = {
                            id: id,
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = resultMsg;
                        return [4, this.callMethod(method, params)];
                    case 2:
                        _a.result = _b.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _b.sent();
                        if (e_1 instanceof util_1.ErrorWithCode) {
                            resultMsg.error = {
                                message: e_1.message,
                                code: e_1.code,
                            };
                        }
                        else if (e_1 instanceof Error) {
                            resultMsg.error = {
                                message: e_1.message,
                            };
                        }
                        return [3, 4];
                    case 4:
                        connector_1.default.emit('message', JSON.stringify(resultMsg));
                        return [2];
                }
            });
        });
    };
    Chobitsu.prototype.register = function (name, methods) {
        var domains = this.domains;
        var domain = domains.get(name);
        if (!domain) {
            domain = {};
            Emitter_1.default.mixin(domain);
        }
        (0, each_1.default)(methods, function (fn, method) {
            domain[method] = fn;
        });
        domains.set(name, domain);
    };
    Chobitsu.prototype.callMethod = function (method, params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, domainName, methodName, domain;
            return __generator(this, function (_b) {
                _a = method.split('.'), domainName = _a[0], methodName = _a[1];
                domain = this.domain(domainName);
                if (domain) {
                    if (domain[methodName]) {
                        return [2, domain[methodName](params) || {}];
                    }
                }
                throw Error("".concat(method, " unimplemented"));
            });
        });
    };
    return Chobitsu;
}());
exports.default = Chobitsu;
